import React from 'react';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({ className = '', width = 80, height = 80 }) => {
  return (
    <div 
      className={`rounded-full overflow-hidden ${className}`}
      style={{ width, height }}
    >
      <img 
        src="/logo-new.png"
        alt="Royal O'Nara Logo" 
        className="w-full h-full object-cover"
        style={{
          transform: 'scale(1.11) translateX(-0.7%) translateY(0.2%)',
          transformOrigin: 'center center'
        }}
      />
    </div>
  );
};

export default Logo;